<template>
  <b-card
    class="chat-unblock-preview"
  >
    <player-chat-unblock-link
      :playerId="playerId"
      :chatUnblockId="object.id"
    />

    <table>
      <tr>
        <th>Unblocker</th>
        <td>
          <user-link
            :user="user"
          />
        </td>
      </tr>
      <tr>
        <th>Time</th>
        <td>{{object.ctime | getMomentMinStr}}</td>
      </tr>
    </table>

  </b-card>
</template>

<script>
import { getUserFromMap } from '../model/user';

import PlayerChatUnblockLink from './PlayerChatUnblockLink.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'PlayerChatUnblockPreview',

  components: {
    PlayerChatUnblockLink,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  computed: {
    user() {
      return getUserFromMap(this.userMap, this.object.userId);
    },
  },
};
</script>

<style scoped>
.chat-unblock-preview .card-body {
  padding: 8px;
}

.chat-unblock-preview th {
  padding-right: .5rem;
}
</style>
